// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__39E0f","errorLogs":"styles_errorLogs__3Lcx-"};